import React, { useState, useEffect } from 'react';
import { Route, Switch, useHistory, Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MenuTab } from '@klarna/bubble-ui';
import { selectors as coreSelectors } from 'mage-core';
import { MoetFlowVisualizer } from '../flow/flow-visualizer';
import { WidgetLinkCreator } from './WidgetLinkCreator';
import OnboardingConfiguration from './OnboardingConfiguration';
import { useStateContext } from '@merchant-portal/framework';
const componentPropTypes = {
    basePath: PropTypes.string.isRequired,
};
const Component = ({ basePath }) => {
    const history = useHistory();
    const location = useLocation();
    const [currentRoute, setCurrentRoute] = useState(location.pathname.split('/')[3] || 'widget');
    const { setState: setFrameworkState = x => x } = useStateContext();
    useEffect(() => {
        setFrameworkState({ hideSidebar: true, hideTopBar: true });
    }, [setFrameworkState]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuTab, { value: currentRoute, onChange: (value) => {
                history.push(`${basePath}/${value}`);
                setCurrentRoute(value);
            }, options: [
                { value: 'widget', label: 'Widget link' },
                { value: 'flow-visualization', label: 'Flow visualization' },
                { value: 'onboarding-config', label: 'Onboarding configuration' },
            ] }),
        React.createElement(Switch, null,
            React.createElement(Route, { path: `${basePath}/`, exact: true, render: () => React.createElement(Redirect, { to: `${basePath}/widget` }) }),
            React.createElement(Route, { path: `${basePath}/widget`, exact: true, render: () => React.createElement(WidgetLinkCreator, null) }),
            React.createElement(Route, { path: `${basePath}/flow-visualization`, exact: true, render: () => React.createElement(MoetFlowVisualizer, null) }),
            React.createElement(Route, { path: `${basePath}/onboarding-config`, exact: true, render: () => React.createElement(OnboardingConfiguration, null) }))));
};
Component.propTypes = componentPropTypes;
export const MoetGUI = connect(state => ({
    basePath: `/${coreSelectors.slug(state)}/gui`,
}))(Component);
